import { mysqlTable, index, primaryKey, int, varchar, tinyint, text, datetime, unique, date, mediumint, double, decimal, smallint, bigint, char } from 'drizzle-orm/mysql-core';

export const bankAccount = mysqlTable(
  'bank_account',
  {
    memberId: int('member_id', { unsigned: true }).notNull(),
    bankCode: varchar('bank_code', { length: 255 }).notNull(),
    branchCode: varchar('branch_code', { length: 255 }).notNull(),
    bankName: varchar('bank_name', { length: 255 }).notNull(),
    branchName: varchar('branch_name', { length: 255 }).notNull(),
    accountNumber: varchar('account_number', { length: 255 }).notNull(),
    accountType: tinyint('account_type', { unsigned: true }).notNull(),
    accountName: text('account_name').notNull(),
    createdAt: datetime('created_at', { mode: 'string' }).notNull(),
    updatedAt: datetime('updated_at', { mode: 'string' }).notNull(),
  },
  (table) => [index('fk_bank_account_member1').on(table.memberId), primaryKey({ columns: [table.memberId], name: 'bank_account_member_id' })],
);

export const event = mysqlTable(
  'event',
  {
    eventId: int('event_id', { unsigned: true }).autoincrement().notNull(),
    promoterId: int('promoter_id', { unsigned: true }).notNull(),
    slug: varchar({ length: 31 }).notNull(),
    title: varchar({ length: 255 }).notNull(),
    description: text().notNull(),
    url: varchar({ length: 255 }).notNull(),
    zipcode: varchar({ length: 15 }).notNull(),
    prefecture: varchar({ length: 15 }).notNull(),
    address: varchar({ length: 255 }).notNull(),
    venue: varchar({ length: 127 }).notNull(),
    // you can use { mode: 'date' }, if you want to have Date as type for this column
    startAt: date('start_at', { mode: 'string' }).notNull(),
    // you can use { mode: 'date' }, if you want to have Date as type for this column
    endAt: date('end_at', { mode: 'string' }).notNull(),
    scheduleComment: varchar('schedule_comment', { length: 255 }).notNull(),
    published: tinyint({ unsigned: true }).default(0).notNull(),
    contact: varchar({ length: 255 }).notNull(),
    createdAt: datetime('created_at', { mode: 'string' }).notNull(),
    updatedAt: datetime('updated_at', { mode: 'string' }).notNull(),
  },
  (table) => [index('fk_event_promoter1').on(table.promoterId), index('ix_event_1').on(table.published, table.startAt, table.endAt), primaryKey({ columns: [table.eventId], name: 'event_event_id' }), unique('uq_event_1').on(table.slug)],
);

export const item = mysqlTable(
  'item',
  {
    itemId: int('item_id', { unsigned: true }).autoincrement().notNull(),
    shopId: int('shop_id', { unsigned: true }).notNull(),
    categoryId: mediumint('category_id').notNull(),
    slug: varchar({ length: 255 }).notNull(),
    price: double().notNull(),
    currency: varchar({ length: 3 }).default('USD').notNull(),
    height: decimal({ precision: 5, scale: 2, unsigned: true }).default('0.00').notNull(),
    width: decimal({ precision: 5, scale: 2, unsigned: true }).default('0.00').notNull(),
    depth: decimal({ precision: 5, scale: 2, unsigned: true }).default('0.00').notNull(),
    stock: smallint({ unsigned: true }).notNull(),
    soldStock: smallint('sold_stock', { unsigned: true }).notNull(),
    weight: mediumint({ unsigned: true }).notNull(),
    orderInShop: double('order_in_shop', { unsigned: true }).notNull(),
    iichiShippingFee: mediumint('iichi_shipping_fee', { unsigned: true }).notNull(),
    published: tinyint().default(0).notNull(),
    isAvailableOverseas: tinyint('is_available_overseas').default(0).notNull(),
    deleted: tinyint().default(0).notNull(),
    publishedAt: datetime('published_at', { mode: 'string' }).notNull(),
    overseasPublishedAt: datetime('overseas_published_at', { mode: 'string' }).notNull(),
    likeCount: int('like_count').default(0).notNull(),
    state: varchar({ length: 255 }).default('').notNull(),
    pv: int({ unsigned: true }).default(0).notNull(),
    isGift: tinyint('is_gift').default(0).notNull(),
    isOrdermade: tinyint('is_ordermade').default(0).notNull(),
    isEspecial: tinyint('is_especial').default(0).notNull(),
    createdAt: datetime('created_at', { mode: 'string' }).notNull(),
    updatedAt: datetime('updated_at', { mode: 'string' }).notNull(),
  },
  (table) => [
    index('fk_item_category1').on(table.categoryId),
    index('ix_item_4').on(table.published, table.deleted, table.price),
    index('ix_item_9').on(table.shopId, table.published, table.deleted, table.orderInShop),
    primaryKey({ columns: [table.itemId], name: 'item_item_id' }),
  ],
);

export const itemCategory = mysqlTable(
  'item_category',
  {
    itemId: int('item_id', { unsigned: true }).notNull(),
    categoryId: mediumint('category_id').notNull(),
    rank: tinyint({ unsigned: true }).default(0).notNull(),
    hierarchy: tinyint({ unsigned: true }).notNull(),
    optionalName: varchar('optional_name', { length: 31 }).notNull(),
    createdAt: datetime('created_at', { mode: 'string' }).notNull(),
    updatedAt: datetime('updated_at', { mode: 'string' }).notNull(),
  },
  (table) => [
    index('fk_item_category_category1').on(table.categoryId),
    index('fk_item_category_item1').on(table.itemId),
    index('ix_item_category_1').on(table.itemId, table.hierarchy),
    primaryKey({ columns: [table.itemId, table.categoryId], name: 'item_category_item_id_category_id' }),
  ],
);

export const itemI18N = mysqlTable(
  'item_i18n',
  {
    itemId: int('item_id', { unsigned: true }).notNull(),
    culture: varchar({ length: 7 }).notNull(),
    title: varchar({ length: 255 }).notNull(),
    translated: tinyint({ unsigned: true }).default(0).notNull(),
    description: text().notNull(),
    aboutShipping: text('about_shipping').notNull(),
    craftPeriod: smallint('craft_period', { unsigned: true }).notNull(),
    aboutCraftPeriod: varchar('about_craft_period', { length: 1023 }).notNull(),
    remark: varchar({ length: 1023 }).notNull(),
  },
  (table) => [index('fk_item_i18n_item1').on(table.itemId), primaryKey({ columns: [table.itemId, table.culture], name: 'item_i18n_item_id_culture' })],
);

export const itemListingFirstLastHistory = mysqlTable(
  'item_listing_first_last_history',
  {
    itemId: int('item_id', { unsigned: true }).notNull(),
    firstListedAt: datetime('first_listed_at', { mode: 'string' }).notNull(),
    lastListedAt: datetime('last_listed_at', { mode: 'string' }).notNull(),
  },
  (table) => [
    index('ix_item_listing_first_last_history').on(table.itemId, table.lastListedAt),
    index('ix_item_listing_first_last_history_2').on(table.lastListedAt),
    primaryKey({ columns: [table.itemId], name: 'item_listing_first_last_history_item_id' }),
  ],
);

export const itemMeta = mysqlTable(
  'item_meta',
  {
    itemId: int('item_id', { unsigned: true }).notNull(),
    metaId: smallint('meta_id', { unsigned: true }).notNull(),
    value: varchar({ length: 255 }).notNull(),
    createdAt: datetime('created_at', { mode: 'string' }).notNull(),
    updatedAt: datetime('updated_at', { mode: 'string' }).notNull(),
  },
  (table) => [index('ix_item_meta_meta_id').on(table.metaId), primaryKey({ columns: [table.itemId, table.metaId], name: 'item_meta_item_id_meta_id' })],
);

export const itemPicture = mysqlTable(
  'item_picture',
  {
    itemId: int('item_id', { unsigned: true }).notNull(),
    order: tinyint({ unsigned: true }).notNull(),
    slug: varchar({ length: 31 }).notNull(),
    contentType: varchar('content_type', { length: 15 }).notNull(),
    text: text().notNull(),
    width: smallint({ unsigned: true }).notNull(),
    height: smallint({ unsigned: true }).notNull(),
    createdAt: datetime('created_at', { mode: 'string' }).notNull(),
    updatedAt: datetime('updated_at', { mode: 'string' }).notNull(),
  },
  (table) => [index('fk_item_picture_item1').on(table.itemId), index('ix_item_picture_1').on(table.itemId, table.order), primaryKey({ columns: [table.itemId, table.order], name: 'item_picture_item_id_order' })],
);

export const likeness = mysqlTable(
  'likeness',
  {
    likenessId: bigint('likeness_id', { mode: 'number', unsigned: true }).autoincrement().notNull(),
    memberId: int('member_id', { unsigned: true }).notNull(),
    linkId: int('link_id', { unsigned: true }).notNull(),
    type: smallint({ unsigned: true }).notNull(),
    createdAt: datetime('created_at', { mode: 'string' }).notNull(),
    updatedAt: datetime('updated_at', { mode: 'string' }).notNull(),
  },
  (table) => [
    index('fk_favorite_member1').on(table.memberId),
    index('ix_likeness_1').on(table.memberId, table.type),
    index('ix_likeness_3').on(table.type, table.linkId),
    index('ix_likeness_type_created_at').on(table.type, table.createdAt),
    primaryKey({ columns: [table.likenessId], name: 'likeness_likeness_id' }),
    unique('uq_likeness_1').on(table.memberId, table.linkId, table.type),
  ],
);

export const member = mysqlTable(
  'member',
  {
    memberId: int('member_id', { unsigned: true }).autoincrement().notNull(),
    slug: varchar({ length: 31 }).notNull(),
    alias: varchar({ length: 255 }).notNull(),
    email: varchar({ length: 255 }).notNull(),
    password: varchar({ length: 255 }).notNull(),
    emailConfirmed: tinyint('email_confirmed').default(0).notNull(),
    emailSuspended: tinyint('email_suspended').default(0).notNull(),
    emailBounceCount: int('email_bounce_count', { unsigned: true }).default(0).notNull(),
    defaultCulture: char('default_culture', { length: 5 }).notNull(),
    defaultCurrency: char('default_currency', { length: 3 }).notNull(),
    likeCount: mediumint('like_count', { unsigned: true }).notNull(),
    deleted: tinyint().default(0).notNull(),
    createdAt: datetime('created_at', { mode: 'string' }).notNull(),
    updatedAt: datetime('updated_at', { mode: 'string' }).notNull(),
  },
  (table) => [
    index('ix_member_1').on(table.alias, table.deleted),
    index('ix_member_2').on(table.slug),
    index('ix_member_3').on(table.deleted, table.email),
    primaryKey({ columns: [table.memberId], name: 'member_member_id' }),
    unique('email_UNIQUE').on(table.email),
  ],
);

export const memberI18N = mysqlTable(
  'member_i18n',
  {
    memberId: int('member_id', { unsigned: true }).notNull(),
    culture: varchar({ length: 7 }).notNull(),
    memberName: varchar('member_name', { length: 255 }).notNull(),
    about: text().notNull(),
  },
  (table) => [index('fk_member_i18n_member1').on(table.memberId), primaryKey({ columns: [table.memberId, table.culture], name: 'member_i18n_member_id_culture' })],
);

export const memberPicture = mysqlTable(
  'member_picture',
  {
    memberId: int('member_id', { unsigned: true }).notNull(),
    slug: varchar({ length: 31 }).notNull(),
    contentType: varchar('content_type', { length: 15 }).notNull(),
    createdAt: datetime('created_at', { mode: 'string' }).notNull(),
    updatedAt: datetime('updated_at', { mode: 'string' }).notNull(),
  },
  (table) => [index('fk_member_picture_member1').on(table.memberId), primaryKey({ columns: [table.memberId], name: 'member_picture_member_id' })],
);

export const orderItem = mysqlTable(
  'order_item',
  {
    orderId: bigint('order_id', { mode: 'number', unsigned: true }).notNull(),
    itemId: int('item_id', { unsigned: true }).notNull(),
    quantity: smallint({ unsigned: true }).notNull(),
    price: int({ unsigned: true }).notNull(),
    currency: char({ length: 3 }).notNull(),
    shippingFee: int('shipping_fee', { unsigned: true }).notNull(),
    status: tinyint({ unsigned: true }).notNull(),
    createdAt: datetime('created_at', { mode: 'string' }).notNull(),
    updatedAt: datetime('updated_at', { mode: 'string' }).notNull(),
  },
  (table) => [index('fk_order_item_item1').on(table.itemId), index('fk_order_item_order1').on(table.orderId), primaryKey({ columns: [table.orderId, table.itemId], name: 'order_item_order_id_item_id' })],
);
